import script from "./PaginatedTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginatedTable.vue?vue&type=script&setup=true&lang=ts"

import "./PaginatedTable.vue?vue&type=style&index=0&id=8b665216&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b665216"]])

export default __exports__